<script lang="tsx">
  import { computed, defineComponent, getCurrentInstance, type PropType } from "vue";

  import { useQuery } from "@urql/vue";
  import { graphql as gql } from "@/gql";
  import type { global_Entry, image_Entry, menuNode_Entry, MenuTreeType, Scalars } from "@/gql/graphql";

  const Footer = defineComponent({
    components: {},
    props: {
      site: {
        type: [Number, String] as PropType<Scalars["QueryArgument"]["input"]>,
        required: true,
      },
    },
    async setup(props) {
      const proxy = getCurrentInstance()!.proxy as InstanceType<typeof Footer>;

      const { data } = await useQuery({
        query: gql(`
          query FetchFooterMenuGlobal($site: QueryArgument, $user: Int) {
            globalEntry(siteId: [$site]) {
              ... on global_Entry {
                id,
                nameSite,
                nameLong,
                copyright,
                menuFooter {
                  ... on menuNode_Entry {
                    tree(user: $user) {
                      label,
                      href,
                      children {
                        label,
                        href,
                        children {
                          label,
                          href,
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `),
        variables: { site: props.site, user: proxy.$session.info.value?.id }
      });

      return {
        tree: computed((): MenuTreeType[] => {
          const tree = [];
          for (const rootNode of data.value!.globalEntry!.menuFooter) {
            if (rootNode?.tree != null) {
              tree.push(rootNode!.tree!);
            }
          }
          return tree;
        }),
        global: computed((): global_Entry => {
          return data.value!.globalEntry! as global_Entry;
        }),
      };
    },
  });

  export default Footer;
</script>

<template>
  <div class="box">
    <div v-for="node in tree">
      <h3>
        <a v-if="node!.href != null"
          :href="node.href">{{ node.label }}</a>
        <span v-if="node!.href == null">{{ node.label }}</span>
      </h3>
      <ul>
        <li v-for="child in node.children">
          <a v-if="child!.href != null"
            :href="child!.href">{{ child!.label }}</a>
          <span v-if="child!.href == null">{{ child!.label }}</span>
        </li>
      </ul>
    </div>
    <div class="span copyright">
      <small>{{ global.copyright }}</small>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .box {
    display: flex;
    flex-wrap: wrap;
    justify-items: flex-start;
    justify-content: center;
    align-items: flex-start;

    padding: var(--spacing-block);
    row-gap: var(--spacing-block);
    color: var(--p-surface-200);

    // column-gap: 2em;

    & > * {
      flex: 1 0 10em;
      width: max-content;
    }

    .span {
      flex-basis: 100%;
      width: min-content;
    }
  }

  .title, .copyright { text-align: center; }

  h3 {
    color: var(--p-surface-400);
  }

  a {
    color: var(--p-primary-600);
    &:not(:hover) {
      text-decoration: none;
    }
  }
</style>
